// removed by extract-text-webpack-plugin
module.exports = {"support":"support___2FdwR","container":"container___3J4JT","column":"column___1Ouds","wrapper":"wrapper___35uBS","column-title":"column-title___3lndx","container-using":"container-using___2jQHG","social-icons":"social-icons___2en7R","email":"email___Wnh9e","twitter":"twitter___1e2_x","facebook":"facebook___1euyb","pinterest":"pinterest___2hLiD","container-copyright":"container-copyright___3sHyI","copyright":"copyright___ryG84","health":"health___1j7hS","sitemap":"sitemap___2VM5j","bold-title":"bold-title___t_KRt","new-site":"new-site___392eu","classic-link":"classic-link___t7Gq1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Support/Support.scss
// module id = XDDN
// module chunks = 46